

































































import BaseComponent from '@/components/base-component.vue';
import RulesEngineRuleOverrideForm from '@/components/rules-engine/rule-override/rule-override-form.vue';
import ListMessages from '@/components/UI/list-messages.vue';
import PermissionAuth from '@/components/UI/permission-auth.vue';
import UiToggleStatus from '@/components/UI/toggle-status.vue';
import { resetModalScroll } from '@/helpers/resetModalScroll';
import { PaginationSyncDTO, ResultPagDTO } from '@/interfaces/base-dto';
import { RestricaoHierarquiaFiltroPagDTO } from '@/interfaces/rules-engine';
import RuleOverrideModel from '@/models/rule-override-model';
import * as service from '@/services/rules-engine';
import {
  REFERENCE_TYPE_CLIENT,
  REFERENCE_TYPE_DOCTOR,
  REFERENCE_TYPE_TEAM
} from '@/settings/consts/rules-engine';
import { BehaviorSubject } from 'rxjs';
import { debounceTime, skipWhile, switchMap } from 'rxjs/operators';
import Component from 'vue-class-component';
import { Prop, Watch } from 'vue-property-decorator';

@Component({
  components: {
    RulesEngineRuleOverrideForm,
    ListMessages,
    PermissionAuth,
    UiToggleStatus
  },
})
export default class RulesEngineOverridesList extends BaseComponent {
  @Prop()
  public rule?: any;
  @Prop()
  public filter?: any;

  @Prop()
  public itemChanged?: any;

  public formOpen: boolean = false;
  public error: boolean = false;
  public loading: boolean = false;

  public ruleFormIsEdit: boolean = false;
  public ruleToEdit: any = null;

  public referencesTypes: any = {
    client: REFERENCE_TYPE_CLIENT,
    team: REFERENCE_TYPE_TEAM,
    doctor: REFERENCE_TYPE_DOCTOR,
  };

  public headers: any = [
    { text: 'Descrição', value: 'descricao' },
    { text: 'Tipo', value: 'acao' },
    { text: 'Unidade / Cliente', value: 'unidade.nome' },
    { text: 'Referência', value: 'referencia', sortable: false },
    { text: 'Tipo de hierarquia', value: 'herarquia', sortable: true },
    { text: 'Ações', value: 'name', sortable: false, align: 'right' },
  ];

  public data: RuleOverrideModel[] = [];

  pagination: PaginationSyncDTO = new PaginationSyncDTO();
  pagina: ResultPagDTO<any> = new ResultPagDTO();

  public hierarchy(type): string {
    if (type) {
      return [
        {
          id: 'CLIENTE',
          value: 'Unidade',
        },
        {
          id: 'MEDICO',
          value: 'Médico',
        },
        {
          id: 'TIME',
          value: 'Time',
        },
        {
          id: 'PACIENTE',
          value: 'Paciente',
        },
      ].find((x) => x.id === type).value;
    }
    return '-';
  }

  mounted() {
    this.registerLoadSubject();
  }

  @Watch('filter', { deep: true })
  public onFilterChange(filter): void {
    this.pagination.page = 1;
    this.load();
  }

  public load(): void {
    this.getRulesOverrides();
  }

  public newRule() {
    this.loader.start('Preparando...')
    service.getRule(this.filter.rule.id).subscribe(rule => {
      this.ruleToEdit = {
        sobrescreve: {
          id: rule.id,
        },
        codigo: rule.codigo,
        acao: rule.acao,
        descricao: rule.descricao,
        mensagem: rule.mensagem,
        textoExplicativo: rule.textoExplicativo,
        condicoes: rule.condicoes,
        ativo: rule.ativo
      };
      this.formOpen = true;
      this.loader.stop();
    }, error => {
      this.loader.stop();
      this.showToastApiError(error);
    });
    this.ruleFormIsEdit = false;
  }

  public closeForm() {
    this.formOpen = false;
    this.ruleToEdit = null;
    this.ruleFormIsEdit = false;
    resetModalScroll();
  }

  public onDeleteItem(item: any) {
    const deleteItem = () => {
      this.loader.start('Deletando registro...');
      service.deleteRule(item.id).subscribe(
        (data) => {
          this.loader.stop();
          this.load();
          this.$emit("afterSave");
        },
        (err) => {
          this.loader.stop();
          this.showToastApiError(err);
        },
      );
    };

    this.dialog.show(
      'error',
      'Excluir Regra',
      'Tem certeza que deseja excluir esta regra?',
      'Cancelar',
      '',
      'Excluir',
      deleteItem,
    );
  }

  public onEditItem(item: any) {
    this.loadIntoForm(item);
  }

  public onCloneItem(item: any) {
    this.loadIntoForm(item, true);
  }

  public loadIntoForm(item: any, clone: boolean = false): void {
    this.loader.start('Carregando regra...');
    service.getRuleOverride(item.id).subscribe(
      (data) => {
        this.loader.stop();
        if (!!clone) {
          data.id = null;
        }
        this.ruleToEdit = data;
        this.ruleFormIsEdit = !clone;
        this.formOpen = true;
      },
      (err) => {
        this.loader.stop();
        this.toast.show('Ocorreu um erro ao carregar a regra', 'error');
      },
    );
  }

  public onRuleSave() {
    this.closeForm();
    this.load();
    this.$emit("afterSave")
  }

  private loadSubject$: BehaviorSubject<any> = new BehaviorSubject(null);
  
  public registerLoadSubject() {
    this.loadSubject$
      .pipe(
        skipWhile((val) => {
          return val === null;
        }),
        debounceTime(300),
        switchMap((filter) => {
          this.loading = true;
          this.error = false;
          this.data = []
          return service.listRulesOverrides(filter);
        }),
      )
      .subscribe(
        (page) => {
          this.data = page.content;
          this.loading = false;
          this.pagina = page;
          PaginationSyncDTO.update(this.pagination, page);
        },
        (error) => {
          this.loading = false;
          this.error = true;
        },
      );
  }

  private getRulesOverrides(): void {
    let filter = new RestricaoHierarquiaFiltroPagDTO();
    filter.idRestricao = !!this.filter.rule ? this.filter.rule.id : null;
    filter.hierarquia = this.filter.referenceType;
    filter.referenciaHierarquia = this.filter.team? this.filter.team : this.filter.doctor? this.filter.doctor : !!this.filter.clientUnit ? this.filter.clientUnit.id : null;
    filter.ativo = this.filter.status;
    filter.update(this.pagination);
    
    this.loadSubject$.next(filter);
  }
  
  public onChangeSatusItem(item, newStatus) {
    this.$emit('changeStatus', item, newStatus);
  }

  @Watch('itemChanged')
  onItemChanged() {
    this.load();
  }

  @Watch('pagination.page')
  @Watch('pagination.rowsPerPage')
  @Watch('pagination.sortBy')
  @Watch('pagination.descending')
  private onChangePagination() {
    if (this.loading) {
      return;
    }
    this.load();
  }

}
